<div>
    <i class="font-20 zmdi zmdi-check green" *ngIf="status === 'success'"></i>
    <i class="font-20 zmdi zmdi-minus blue" *ngIf="status === 'pending'"></i>
    <i class="font-20 zmdi zmdi-close red" *ngIf="status === 'failed'"></i>
    <i class="font-20 zmdi zmdi-close orange" *ngIf="status === 'cancelled'"></i>
</div>
